var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHonktext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 53,
    viewBox: "0 0 68 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8217 25.0214C10.9023 27.6631 9.48117 30.1041 7.87408 32.355C7.35314 33.0846 6.68588 33.6939 6.26664 34.5033C6.0055 35.0075 6.17116 34.835 6.51873 34.67C7.48171 34.2127 8.50527 34.0189 9.47617 33.5835C10.8359 32.9738 12.1346 32.1973 13.4854 31.5606C14.6512 31.0111 15.7799 30.3694 16.9453 29.8201C17.4077 29.6022 17.8894 29.4355 18.3176 29.1373C19.3478 28.4197 20.4357 29.6206 21.3249 30.0338C24.3855 31.4562 27.4957 32.7762 30.7446 33.7068C33.3824 34.4623 36.148 34.6662 38.7916 35.3705C41.0861 35.9818 43.5857 36.3208 45.9833 36.3734C48.9371 36.4382 51.7658 36.8124 54.735 36.0325C57.877 35.2072 60.2191 33.1999 62.5316 30.741C64.2189 28.9469 64.8208 27.0246 63.8953 24.7975C63.0541 22.7736 61.4686 21.1465 59.9714 19.6901C58.4597 18.2195 56.63 17.1971 54.859 16.1347C50.7503 13.6697 46.3169 12.1593 41.8312 10.5982C36.9389 8.89558 32.001 7.41406 26.7686 7.06131C24.5895 6.91441 22.4038 6.76703 20.2177 6.70772C18.9979 6.67463 17.7602 6.77057 16.5457 6.70867C15.587 6.65981 14.6575 6.53747 13.6866 6.6215C11.1585 6.84032 8.89066 8.34915 7.6769 10.8691C7.30806 11.6349 6.97527 12.4421 6.97295 13.2766C6.97035 14.2158 7.11585 15.0979 7.2133 16.0285C7.38012 17.6217 7.76559 19.1108 8.49264 20.4525C9.27892 21.9034 10.5722 24.0182 12.1113 24.5538",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.568 12.2891C18.0304 13.8337 17.38 15.3395 16.8453 16.8761C16.5542 17.7126 16.0947 18.6379 16.0537 19.5136",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7862 15.9955C18.4842 16.1451 19.2805 16.1353 19.9553 16.3241C20.2461 16.4055 21.0219 16.8668 21.2441 16.6305",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6111 12.7012C23.0013 13.0522 21.9268 15.3793 21.769 15.85C21.5783 16.4184 21.4938 17.0052 21.2964 17.5723C21.1693 17.9375 20.9454 18.3692 20.9123 18.757C20.824 19.7923 20.236 20.9839 19.8878 21.9844",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8271 15.9379C26.3944 15.4393 25.5503 19.6476 25.2794 20.7272C24.9516 22.0333 26.5089 22.8812 27.4787 22.7715C28.4526 22.6613 29.4049 20.8575 29.7985 20.0343C30.1777 19.2412 30.8495 17.7524 30.5428 16.883C30.1917 15.8874 29.2876 15.6075 28.343 15.549",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8389 24.5023C33.4571 22.7258 34.1472 20.9605 34.5846 19.1418C34.7554 18.4319 35.2717 17.1991 35.3622 18.7098C35.428 19.808 35.4659 20.9834 35.62 22.0598C35.7107 22.6942 35.7584 23.5636 36.1627 24.0644C36.4412 24.4093 36.528 24.7707 36.7369 25.1484C36.8405 25.3357 36.9981 25.4465 37.1481 25.6073C37.2849 25.7539 37.762 23.7549 37.8169 23.5033C38.1617 21.923 38.8479 20.3584 39.3826 18.8222",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3422 20.2003C42.7111 22.0139 41.9085 23.9541 41.6867 25.8686C41.6147 26.49 41.3425 27.0196 41.3937 27.6218",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2145 21.8322C46.0063 22.5034 44.72 23.139 43.6814 24.1471C43.392 24.428 43.0256 24.4713 42.7423 24.7597C42.313 25.1968 42.4968 24.9155 43.0144 25.2333C43.5404 25.5563 44.1234 25.8534 44.6049 26.2526C44.9363 26.5274 45.3606 26.9422 45.7416 27.1377C46.3163 27.4325 46.4554 28.2465 47.0649 28.4587",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4316 23.2854C52.9567 24.6502 52.8486 26.0541 52.3792 27.4031C52.2488 27.7777 52.2022 28.1902 52.233 28.5521",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7537 30.6587C51.8414 30.7038 51.8258 30.8163 51.8669 30.6981",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonktext);
export default __webpack_public_path__ + "static/media/honktext.9593ff5f20363071511a47a8c382615a.svg";
export { ForwardRef as ReactComponent };